import { render } from "./Example.vue?vue&type=template&id=07b4b668"
const script = {}

import exportComponent from "/Users/lianyue/Project/vue-upload-component/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__